import styled from 'styled-components'
import { Layout, Typography, Divider } from 'antd'
import AkaButton from '../../../components/button'

const { Content } = Layout
const { Title, Paragraph, Text } = Typography

export const StyledContent = styled(Content)`
	padding: 24px 48px;
	max-width: 1200px;
	margin: 0 auto;
`

export const StyledCenteredContainer = styled.div`
	text-align: center;
	padding: 100px 0;
`

export const StyledEmptyDescription = styled.p`
	margin-top: 16px;
	color: #8c8c8c;
`

export const StyledPageTitle = styled(Title)`
	margin-bottom: 32px !important;
`

export const StyledSystemSection = styled.div`
	margin-bottom: 48px;
`

export const StyledDivider = styled(Divider)`
	margin-top: 48px;
	margin-bottom: 32px;
`

export const StyledConfirmationText = styled(Paragraph)`
	font-size: 16px;
	margin-bottom: 24px;
	font-weight: 500;
`

export const StyledAcceptButton = styled(AkaButton)`
	width: auto !important;
`

// LicenseContractsPage specific styles
export const StyledDocumentsLabel = styled(Text)`
	margin-bottom: 8px;
	display: block;
`

export const StyledDocumentRow = styled.div`
	margin-bottom: 8px;
`
